// Action Types
export const FETCH_KEY_TECHNOLOGY_REQUEST = "FETCH_KEY_TECHNOLOGY_REQUEST";
export const FETCH_KEY_TECHNOLOGY_SUCCESS = "FETCH_KEY_TECHNOLOGY_SUCCESS";
export const FETCH_KEY_TECHNOLOGY_FAILURE = "FETCH_KEY_TECHNOLOGY_FAILURE";

// Action Creators
export const fetchKeyTechnologiesRequest = (company) => {
return (dispatch) => {
  dispatch({
    type: FETCH_KEY_TECHNOLOGY_REQUEST,
    payload: company,
  });
};
};
export const fetchKeyTechnologiesSuccess = (data) => ({
  type: FETCH_KEY_TECHNOLOGY_SUCCESS,
  payload: data,
});
export const fetchKeyTechnologiesFailure = (error) => ({
  type: FETCH_KEY_TECHNOLOGY_FAILURE,
  payload: error,
});
